
import SelectRoutingRepository from "../domain/data/SelectRoutingRepository";
import SelectRouting from "../domain/entities/SelectRouting";
import User from "../domain/entities/User";
import AwsApiClient from "../presentation/hooks/AwsApiClient";

export default class APISelectRoutingRepository
  implements SelectRoutingRepository
{
  private client = new AwsApiClient();

  async saveSelectRouting(
    user: User,
    selectRouting: SelectRouting
  ): Promise<SelectRouting> {
    try {
      const response = await this.client.post(
        `/api/selectRouting`,
        selectRouting
      );
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }

  async deleteSelectRouting(
    user: User,
    selectRouting: SelectRouting
  ): Promise<boolean> {
    try {
      const response = await this.client.delete(
        `/api/selectRouting/${user.organization.id}/${user.id}/${selectRouting.id}`,
        "none"
      );
      return true;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }

    async getSelectRoutings(user: User): Promise<SelectRouting[]> {
    try {
      const response = await this.client.get(
        `/api/selectRouting/${user.organization.id}/${user.id}`
      );
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }
}
